module.exports = __webpack_public_path__ + "img/step410_down.fefd5386.png";